import { render, staticRenderFns } from "./program.vue?vue&type=template&id=489d2534&scoped=true&"
var script = {}
import style0 from "./program.vue?vue&type=style&index=0&id=489d2534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d2534",
  null
  
)

export default component.exports